import { createInstance } from "@optimizely/react-sdk";

const optimizely = createInstance({
  sdkKey: process.env.REACT_APP_OPTIMIZELY_KEY,
});
export default optimizely;
